import styled from 'styled-components';

import { Badge } from './badge';
import { IAccentBadgeProps } from './types';

export const AccentBadge = styled(Badge)<IAccentBadgeProps>`
  color: ${Styles.color.white};
  background-color: ${Styles.color.accent};
`;
